import ImageWithFallback from '@components/ImageWithFallback/ImageWithFallback';
import { usePresetVideos } from '@hooks/api';
import platformIcons from '@static/images/platform';
import avatarPlaceholder from '@static/vectors/placeholders/avatar-placeholder.svg';
import videoPlaceholder from '@static/vectors/placeholders/video-placeholder.svg';
import { FormattedMessage, FormattedNumber } from 'react-intl';
import { Link } from 'react-router';
import type { ShowcaseItem } from 'src/types/sentinel';
import './Showcases.css';

export default function Showcases() {
	const presetData = usePresetVideos();
	const showcases: ShowcaseItem[] = presetData.videos;

	return (
		<section id="demos-showcase">
			{showcases.map((item) => {
				const { video_url, thumbnail_url, description, platform, channel_data } = item;
				const { avatar_url, followers, name } = channel_data;
				return (
					<article id={`showcase-demo-card-${video_url}`} className="showcase-demo-card" key={video_url}>
						<section className="thumbnail-wrapper">
							<span className="icon icon-play" />
							<ImageWithFallback src={thumbnail_url || undefined} fallbackSrc={videoPlaceholder} alt={`${name} video thumbnail`} />
						</section>
						<section className="content-wrapper">
							<div className="channel-data">
								<img src={platformIcons[platform]} alt={`${platform} icon`} />
								<ImageWithFallback
									className="channel-avatar"
									src={avatar_url || undefined}
									fallbackSrc={avatarPlaceholder}
									alt="Channel avatar"
								/>
								<h3 title={name} className="ellipsis">
									{name}
								</h3>
								<span className="followers">
									<span>#</span>
									<FormattedNumber value={followers} notation="compact" maximumFractionDigits={2} />
								</span>
							</div>
							<p className="description truncate" title={description}>
								{description}
							</p>
							<Link to={`/sentinel/process?url=${encodeURIComponent(video_url.trim())}`} className="button run-button">
								<span className="icon icon-play" />
								<span>
									<FormattedMessage id="sentinel-home.run-button" />
								</span>
							</Link>
						</section>
					</article>
				);
			})}
		</section>
	);
}
